import config from 'scoreboard/components/config'
import _ from 'lodash'

export default function (model) {
	let attributes = model.attributes || model
	let classified = _.isNil(attributes.syncId) || !!attributes.originallyDocked
	if (attributes.type == 'bookmark') {
		classified = attributes.classified
	}
	if (classified && config.replicationInputEnabled) {
		let style = _.get(attributes,'className', '')
		attributes.className = style + (style.length ? ' ' : '') + 'sipr-item'
	}
	return attributes
}
